const deleteKuperShiftGroupDenied = {
    title: 'Ошибка удаления',
    description: 'Нельзя удалить реестр, смены которого <b>уже импортированы</b> в акты',
    buttonText: 'Понятно',
    mode: 'denied',
} as const;

export default deleteKuperShiftGroupDenied;
